export default class Resources {
  static FuelTypes = {
    GAS: 'gas',
    ELECTRICITY: 'electricity',
  };

  static SessionStorageKeys = {
    IsNewFlow: '_NF',
    IpAddress: 'ip',
    Postcode: '_PC',
    Email: '_E',
    IsCampaign: '_CAMP',
    IsConsentApproval: '_CA',
    IsAccessToken: '_AT',
    IsAddressBlocked: '_AB',
    PersonalDetails: '_PD',
    SelectedAddress: '_SA',
    CorrelationId: '_CI',
    CurrentUsage: '_CU',
    SavedDetail: '_SD',
    NetzeroAPI: '_NAT',
    IsEditSupplier: '_ES',
    Frequency: '_F',
    DnoId: '_DNO',
    IsNotNow: '_NN',
    IsCompleted: '_IC',
    IsSMCRegistered: '_SMCR',
    IsExceptionFlow: '_EX',
    EVDETAILS: '_EV',
    EV_OWNERSHIP: '_EVO',
    TealiumData: '_TEAL',
    ActionItem: 'A_T',
    FuturePrice: 'F_P',
    IsNewAddress: '_NA',
    IsRemoveSMC: '_RSMC',
    MarketingConsentChannels: '_MC',
    GoogleAnalyticsUuid: 'ga_uuid',
    QuotesData: '_QD',
    AllQuotes: '_QT',
    UpdateusageFromQuotes: 'U_QT',
    SelectedQuote: 'S_QT',
    QuotesID: 'QID',
    IsTopQuote: 'I_TQ',
    RewardBannerId: 'R_BID',
    
    IsConsentGiven: '_CG',
    EVCompareData: 'evCompareData',
    EVCurrentData: 'evCurrentData',
    CarbonFootPrintNeighbours: 'carbonFootPrintNeighbours',
    NeighbourHoodComparision: 'neighbourHoodComparision',
    CarbonFootPrintCustomer: 'carbonFootPrintCustomer',
    IsNoQuotes: 'isNoQuotes',
    EVUpdateDetails: 'evUpdateDetails',
    PreferenceData: 'preferenceData',
    FromEditDetails: 'fromEditDetails',
    FromExceptionalFlow: 'fromExceptionalFlow',
    ExceptionData: 'exceptionData',
    EditDetailsData: 'editDetailsData',
    BackFromSwitchPage: 'backFromSwitchPage',
    QuoteKey: 'quoteKey',
    FilterOnLoad: 'filterOnLoad',
    SupplierToSwitch: 'supplierToSwitch',
    PaymentID: 'paymentID',
    SwitchInProgress: 'switchInProgress',
    IsBankDetailsPresent: 'isBankDetailsPresent',
    UserInfo: 'userInfo',
    IsChecked: 'isChecked',
    FromExceptionalFlowDummy: 'fromExceptionalFlowDummy',
    IsAutoSwitchFlow: 'isAutoSwitchFlow',
    IsAddAddressFlow: 'isAddAddressFlow',
    SignUpWithoutQuotes: 'signUpWithoutQuotes',
    PaidTosave: 'paidTosave',
    CurrentAddressId: 'currentAddressId',
    NetzeroAPIPayLoad: 'netzeroAPIPayLoad',
    DefaultEAC: 'defaultEAC',
    AutoAlertPostcode: 'autoAlertPostcode',
    AccessToken: 'access_token',
    IsErrorflow: 'isErrorflow',
    ErrorMsgNoMPAN: 'errorMsgNoMPAN',
    IsOfferExpired: 'isOfferExpired',
    CurrentSuppData: 'currentSuppData',
    IsAutoAlertAddAddressFlow: 'isAutoAlertAddAddressFlow',
    IsAddressForQuoteLink: 'isAddressForQuoteLink',
    IsAutoSwitchFlowQuotes: 'isAutoSwitchFlowQuotes',
    AddressToken: 'addressToken',
    SectionName: 'sectionName',
    P2stariffError: 'p2stariffError',
    MonthlyYearltToggle: 'monthlyYearltToggle',
    ConsentUrl: 'consentUrl',
    IsUserSubscribed: 'isUserSubscribed',
    IsSmart: 'isSmart',
    IsDismissNotSmartMeter: 'isDismissNotSmartMeter',
    Token: 'token',
    MoveInDate: 'moveInDate',
    IsDisableStripe: 'isDisableStripe',
    IsQuotaReached: 'isQuotaReached',
    IsDismissQuotaLimit: 'isDismissQuotaLimit',
    IsSMCFeatureEnable: 'isSMCFeatureEnable',
    IsSwitchingJourney: 'isSwitchingJourney',
    SwitchedSupplier: 'switchedSupplier',
    IsuserResubscribe: 'isuserResubscribe',
    IsUserVisitedConsent: 'isUserVisitedConsent',
    fdo: 'fdo',
    ChangedFilterdata: 'changedFilterdata',
    AuthorizeIdToken: 'authorizeIdToken',
    FastSwitchAction: 'fastSwitchAction',
    OptionSelect: 'optionSelect',
    IsBackFromQuotes: 'isBackFromQuotes',
    SwitchConfirmed: 'switchConfirmed',
    CampaignId: 'campaignId',
    IsLoggedIn: 'isLoggedIn',
    GasTariffId: 'gasTariffId',
    ElecTariffId: 'elecTariffId',
    MeterDetails: 'meterDetails',
    EnergyType: 'energyType',
    IsSameSupplier: 'isSameSupplier',
    EnergyTariffDuration: 'energyTariffDuration',
    PartialPostcode: 'partialPostcode',
    UserAddresses: 'userAddresses',
    MultiAddAddress: 'multiAddAddress',
    IsAddressChanges: 'isAddressChanges',
    CorrelationIdwithAddress: 'correlationIdwithAddress',
    IsAddressAdded: 'isAddressAdded',
    LoggedInUserPersistant: 'loggedInUserPersistant',
    GBGVersion: 'gbgVersion',
    DetailsEdited: 'detailsEdited',
    MPAN: 'mpan',
    MPRN: 'mprn',
    ResetFilters: 'resetFilters',
    QuotesEnergyType: 'quotesenergytype',
    CurrentUsageLoggedIn: 'currentUsageLoggedIn',

    SmartMeterLink: 'SmartMeterLink',
    dummyCurrentUsageAfterLogin: 'dummyCurrentUsageAfterLogin',
    LoginMeterDetailsUpdatedToSmart: 'LoginMeterDetailsUpdatedToSmart',
    PSRVulnerability: 'psrVulnerability',
    DefaultPSRVulnerability: 'defaultPSRVulnerability',
    IsSameTariff: 'isSameTariff',
    NoDataAvailableInSavedDetails: 'noDataAvailableInSavedDetails',
    ApplicationFormSchema: 'applicationFormSchema',
    SupplierConfig: 'supplierConfig',
    IsFasterSwitching: 'isFasterSwitching',
  };

  static SessionKey = {
    key: 'ngOnInit()',
  };

  static ErrorMessages = {
    MeterStatusError: 'METER_STATUS_ERROR',
    MeterProfileClassError: 'METER_PROFILE_CLASS_ERROR',
    CampaignInvalidEmail: 'CAMPAIGN_INVALID_EMAILID',
    RetentionValidationFailed: 'RETENTION_VALIDATION_FAILED'
  }

  static ProductConfig = {
    SupplierRedirect: 'SUPPLIER_REDIRECT',
  }

  static Regex = {
    evReg: /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/,
    firstName: /^(?![-'])[a-zA-Z-\' ]*$/,
    lastName: /^(?![-'])[a-zA-Z-\' ]*$/,
    Postcode: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/,
    Email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    Mobile: /^(01[0-9]{9}|02[0-9]{9}|03[0-9]{9}|04[0-9]{9}|05[0-9]{9}|06[0-9]{9}|07[0-9]{9}|08[0-9]{9}|09[0-9]{9})$/,
    MPAN: /^(?=\d{10,13}$)\d+$/,
    MPRN: /^(?=\d{6,10}$)\d+$/,
    AccountHolder: /^(?![-'])[a-zA-Z-\' ]*$/,
    AccountNumber: /^(?!(?:0{8}|01234567|12345678))(\d){8}$/,
    SortCode: /^(?!(?:0{6}|012345|123456))(\d){6}$/
  }

  static SwitchStatus = {
    'SWITCH_IN_PROGRESS': 'Switch in progress',
    switchInProgress: 'SWITCH_IN_PROGRESS',
    'SWITCH_CANCELLED': 'Switch cancelled',
    switchCancelled: 'SWITCH_CANCELLED',
    'SWITCH_REJECTED': 'Switch rejected',
    switchRejected: 'SWITCH_REJECTED',
    'SWITCH_COMPLETED': 'Switch completed',
    switchCompleted: 'SWITCH_COMPLETED',
  }

  static SMC_STATUS = {
    'IN_PROGRESS': 'IN_PROGRESS',
    'UNAVAILABLE': 'UNAVAILABLE',
    'CONSENT_SIGNED': 'CONSENT_SIGNED'
  }

  static EnergyType = {
    B: 'Gas & Electricity',
    E: 'Electricity',
    G: 'Gas',
    '1': 'B',
    '2': 'E',
    '3': 'G',
    BOTH: 'B',
    ELECTRICITY: 'E',
    GAS: 'G'
  }

  static EditInformation = {
    Frequency: 'frequency',
    'DURATION_TYPE': {
      'ANNUALLY': 'Annually',
      'MONTHLY': 'Monthly'
    },
    'TOGGLE_TYPE': {
      'ENERGY_USAGE': 'Energy-usage',
      'CURRENT_SPEND': 'Current-spend'
    }
  }

  static ABtestingKeys = {
    LANDING_PAGE_VARIANT_COOKIE: 'landing_page_variant',
    CTM_FLOW_VARIANT_COOKIE: 'ctm_flow_variant'
  }
}